module.exports = __webpack_public_path__ + "img/44.9baf4e2e.jpg";